import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { Icon, Div, Text } from '@pinpoint/design-kit';
import Button from 'src/components/button';
import BaseDialog from './base';
/* eslint-disable react/prop-types */

export function DownloadDialog({ isOpen, actions, modelId, downloads = [] }) {
  useLayoutEffect(() => {
    ReactTooltip.rebuild();
  });
  return (
    <BaseDialog
      isOpen={isOpen}
      actions={{ close: actions.close, cancel: actions.cancel }}
      title={{
        text: 'Downloads',
        backgroundColor: 'brand300',
        color: 'white',
        textSize: 'title',
      }}
      items={{
        content: [
          // TODO: Add deletion of scores
          ...downloads.map(({ bucket, key, name, type, id, entityId }, idx) => (
            <Div d="flex" flexDir="row" justify="space-between" align="center" m={{ t: idx !== 0 ? '1.25rem' : '0' }}>
              <Text textSize="subtitle" textColor="tabSelected">
                {name.replace(' (REMEDIATED)', '')}
              </Text>
              <Div flexGrow="1" />
              <Button
                buttonStyle="primary"
                m={{ r: '0rem' }}
                onClick={() => actions.handlers[0].on(entityId, 'clusters', id)}
              >
                <Icon
                  color="white"
                  name="Download2"
                  viewBox="0 0 14 14"
                  size=".875rem"
                  cursor="pointer"
                  m={{ r: '1rem' }}
                />
                <Text textWeight="500">DOWNLOAD</Text>
              </Button>
            </Div>
          )),
        ],
      }}
    />
  );
}

/* eslint-disable react/require-default-props */
DownloadDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    cancel: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    close: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    handlers: PropTypes.arrayOf(
      PropTypes.shape({
        before: PropTypes.func,
        on: PropTypes.func.isRequired,
        after: PropTypes.func,
      })
    ),
  }).isRequired,
  title: PropTypes.shape({
    text: PropTypes.string.isRequired,
    textSize: PropTypes.string,
    backgroundColor: PropTypes.string.isRequired,
    color: PropTypes.string,
  }),
  items: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.element).isRequired,
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        textSize: PropTypes.string,
        close: PropTypes.bool.isRequired,
      }).isRequired
    ),
  }).isRequired,
  downloads: PropTypes.arrayOf(PropTypes.shape({})),
};
/* eslint-enable */

export default DownloadDialog;
